<template>
<div>
  <!-- 雲林幣兌換結果抽屜 -->
  <a-drawer
    placement="top"
    :closable="true"
    :visible="drawerVisible"
    @close="onDrawerClose"
    :height="200"
    :mask="true"
    :maskClosable="true"
    :zIndex="2000"
    :getContainer="false"
  >
    <div class="coin-result-content">
      <div class="coin-result-icon" :class="coinResultType">
        <a-icon :type="coinResultType === 'success' ? 'check-circle' : 'close-circle'" />
      </div>
      <div class="coin-result-message">
        <h3>{{ coinResultTitle }}</h3>
        <p>{{ coinResultMessage }}</p>
      </div>
    </div>
  </a-drawer>

  <a-spin :spinning="iconLoading" tip="下載中..." size="large">    
    
    <div id="itemlist" class="overflow-auto" style="height: 700px">      
      <div style="height: 960px">
        <div style="padding: 0.6rem 0 0 0" />
        <a-spin :spinning="spinnings" tip="資料處理中...">
          <b-card
            border-variant="secondary"
            header-border-variant="secondary"
            style="font-size: 14px"
            :header="' '"
            v-for="item in aclist"
            :key="item.id"
            class="text-left mb-2"
          >
            <b-card-text>
              <div class="position-relative" style="width: 100%">
                <b-avatar
                  size="46px"
                  style="margin-top: -2.7rem; margin-left: 5rem"
                  :src="item.priUrl"
                  class="position-absolute top-2 end-2"
                ></b-avatar>
              </div>
              <div style="padding: 0.02rem">
                <span style="margin-top: 0.02rem"
                  >姓名: {{ item.username }}</span
                ><br />
                <span
                  slot="extra"
                  v-text="'住址 : ' + geaddr(item.address)"
                ></span>
                <span
                  slot="extra"
                  class="font-weight-bold"
                  :style="{ color: item.states == 'Y' ? '#000099' : '#990033' }"
                  v-text="item.states == 'Y' ? '(已報到)' : '(未報到)'"
                ></span>
              </div>
              <a-button
                style="margin-top: 0.06rem; margin-bottom: -1rem"
                block
                slot="actions"
                type="primary"
                v-if="item.states == 'N' || item.states == ''"
                @click="enterOrder(item)"
              >
                手動報到
              </a-button>            
            </b-card-text>
          </b-card>
          <a-button
            v-show="aclist.length>0 && myDataCheck"
            style="margin-bottom: 10px;padding:10px;"
            :loading="spinnings"
            @click="infiniteHandler()"
            type="danger"
            block
            shape="round"
            size="large"
            >
          <b-icon
              v-show="!spinnings"
              style="margin-right: 0.3rem"
              scale="1.1"
              icon="cloud-download"
              variant="light"
            />
            取得更多資料
        </a-button>  
        </a-spin>
        <div style="padding: 3.5rem 0 0 0" />
      </div>
    </div>
  </a-spin> 
</div> 
</template>

<script>
import * as moment from "moment/moment";
import { joinService } from "../../_services";
import { mapState } from "vuex";
//import router from '../../router'

const findall = (obj) => {
  return joinService.singlistall(obj);
};
const postData = (params) => {
  return joinService.signin(params);
};

export default {
  name: "Order",
  props: {
    fid: Number,
    aid: Number,
    objRS: Object,
  },
  data() {
    return {
      page: 1,
      checkgo: false,
      loading: false,
      aclist: [],
      items: "",
      iconLoading: false,
      spinnings: false,
      myDataCheck:true,
      // 雲林幣兌換結果抽屜控制
      drawerVisible: false,
      coinResultType: 'success', // 'success' 或 'error'
      coinResultTitle: '',
      coinResultMessage: '',
    };
  },
  computed: {
    ...mapState("account", ["user"]),
    getPeople() {
      let number = 0;
      for (var i in this.objRS.acts_actclass) {
        if (this.objRS.acts_actclass[i].aid == this.aid) {
          number = this.objRS.acts_actclass[i].acts_actstaff.length;
          break;
        }
      }
      return number;
    },
  },

  methods: {
    fdateformat(val) {
      return (
        moment(val.sdate).format("YYYY-MM-DD HH:mm") +
        "~" +
        moment(val.edate).format("MM-DD HH:mm")
      );
    },
    catImg(imgs) {
      return require(`../../assets/img/${imgs}`);
    },

    getxt(val) {
      return val.substring(1, 32);
    },

    geaddr(val) {
      return val.substring(0, 6);
    },

    godata(val) {
      this.fid = val;
      this.infiniteHandler();
    },

    // 顯示雲林幣兌換結果抽屜
    showCoinResult(type, title, message) {
      console.log('showCoinResult 被調用:', { type, title, message });
      this.coinResultType = type;
      this.coinResultTitle = title;
      this.coinResultMessage = message;
      this.drawerVisible = true;
      console.log('設定後的狀態:', {
        coinResultType: this.coinResultType,
        coinResultTitle: this.coinResultTitle,
        coinResultMessage: this.coinResultMessage,
        drawerVisible: this.drawerVisible
      });
      
      // 3秒後自動關閉
      setTimeout(() => {
        console.log('自動關閉抽屜');
        this.drawerVisible = false;
      }, 3000);
    },

    // 關閉抽屜
    onDrawerClose() {
      this.drawerVisible = false;
    },

    async enterOrder(obj) {
      let val = {
        id: this.aid,
        sdate: obj.sdate,
        edate: obj.edate,
        fid: obj.fid,
        uid: obj.uid,
        code: "",
        sid: this.user.data.user.id,
      };
      this.spinnings = true;
      await this.toOrder(val)
        .then((val) => {
          return val;
        })
        .catch((val) => {
          return val;
        })
        .finally(() => {
          console.log("done");
        });
    },

    async toOrder(val) {
      return new Promise((resolve, reject) => {
        let now = moment();
        var dateTimeString = val.sdate;
        var parsedMoment = moment(dateTimeString, "YYYY-MM-DD HH:mm");
        var oneHourBefore = parsedMoment.subtract(1, 'hours');
        var myDates = oneHourBefore.format('YYYY-MM-DD HH:mm');   

        var dateTimeString2 = val.edate; //晚一小時
        var parsedMoment2 = moment(dateTimeString2, "YYYY-MM-DD HH:mm");
        var oneHourAfter = parsedMoment2.add(1, 'hours');
        var myDates2 = oneHourAfter.format('YYYY-MM-DD HH:mm');        

        let tmp = { msg: "done", code: 300, data: {} };
        if (
          myDates <=
          now.format("YYYY-MM-DD HH:mm") &&
          myDates2 >
            now.format("YYYY-MM-DD HH:mm")
        ) {
          val.sdate = moment(val.sdate).format("YYYY-MM-DD HH:mm");
          val.edate = moment(val.edate).format("YYYY-MM-DD HH:mm");
          postData({
            ...val,
          }).then(({ data }) => {
            if (data.data.code == 200) {
              this.spinnings = false;
              for (var item in this.aclist) {
                if (this.aclist[item].uid == val.uid) {
                  this.aclist[item].states = "Y";
                  break;
                }
              }
              
              // 判斷雲林幣兌換狀態
              if (data.data.api_call_status === "SUCCESS") {
                this.showCoinResult('success', '雲林幣兌換成功', '恭喜您成功兌換雲林幣！');
              } else if (data.data.api_call_status === "FAIL") {
                this.showCoinResult('error', '雲林幣兌換失敗', data.data.api_call_message);
              } else if (data.data.api_call_status === "PROCESSING") {
                this.showCoinResult('success', '雲林幣兌換處理中', '兌換處理中，請稍後查看結果');
              }
              
              resolve(data);
            } else {
              this.spinnings = false;
              reject(tmp);
            }
          });
        } else {
          setTimeout(() => {
            this.spinnings = false;
          }, 500);          
          reject(tmp);
        }
      });
    },

    async infiniteHandler() {
      this.iconLoading = true;
      let params = {
        page: this.page,
        fid: this.fid,
        aid: this.aid,
      };
      let rs=await this.getOrder(params)
      this.iconLoading = false;
      if(!rs){
        this.myDataCheck=false;
      }
    },

     getOrder(params) {
      return new Promise((resolve) => {
        this.page++;
        findall({
          ...params,
        }).then(({ data }) => {
          let obj = {
            hits: data.data,
          };
          if (obj.hits == null) {
            obj.hits = [];
          }
          if (obj.hits.length) {
            this.aclist.push(...obj.hits);
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
  },
  created() {
    this.infiniteHandler();
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#itemlist {
  margin: 0px auto;
  padding: 0px;
  max-width: 1024px;
}

img {
  max-width: 100%;
  min-height: 100%;
  object-fit: cover;
  display: block;
  clip-path: polygon(-4px -4px, 100.4% -3px, 99.2% 102.57%, -0.8% 102.97%);
}

.cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto;
  width: min(98%, 500px);
  margin: 0 auto;
  box-shadow: 0 20px 34px hsla(20deg, 1%, 52%, 0.29);
  overflow: hidden;
}

.cards-details {
  position: relative;
  padding: 0 0.05rem 0 0.5rem;
}

.fontstyle {
  font-size: 0.8rem;
  color: #ffffff;
}

.spin-content {
  padding: 60px;
  box-shadow: 0 20px 34px hsla(20deg, 1%, 52%, 0.29);
}

/* 雲林幣兌換結果抽屜樣式 */
.coin-result-content {
  display: flex;
  align-items: center;
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 8px;
  margin: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 2001;
}

.coin-result-icon {
  font-size: 48px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.coin-result-icon.success {
  color: #52c41a;
  background: rgba(82, 196, 26, 0.1);
}

.coin-result-icon.error {
  color: #ff4d4f;
  background: rgba(255, 77, 79, 0.1);
}

.coin-result-message h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: bold;
}

.coin-result-message p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.4;
}
</style>





